import React, { useEffect, useRef, useState } from "react";
import { FaGithub, FaGlobe } from "react-icons/fa";
import "../styles/projects.css";

export default function Projects() {
  const SPEED_MULTIPLIER = 0.5; // 50% faster
  const AUTO_PLAY_INTERVAL = 4000 * SPEED_MULTIPLIER; // = 2000ms
  const RESUME_DELAY = 3000; // ms

  const scrollRef = useRef(null);
  const stopRef = useRef(false);
  const userScrolledRef = useRef(false);
  const resumeTimeoutRef = useRef(null);
  const playIntervalRef = useRef(null);

  const [cardWidth, setCardWidth] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);

  const projects = [
    {
    title: "HealthMate - Doctor Appointment Booking System",
    description:
      "A modern full-stack MERN application for booking doctor appointments online with secure payments and admin management.",
    image: "/assets/project0.png",
    links: {
      github: "https://github.com/ashwindumane/HealthMate-Doctor-Appointment-Booking-System", // 🔹 Replace with actual repo
      live: "https://healthmate-doctor-appointment-booki.vercel.app/", // 🔹 Replace with your live demo
    },
    tech: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "JWT",
      "Tailwind CSS",
      "Razorpay",
      "Cloudinary",
    ],
  },{
  title: "AWS Event-Driven Serverless ETL Data Lake",
  description:
    "Fully serverless event-driven ETL pipeline on AWS that processes nested JSON, converts to Parquet, catalogs schema using Glue, and enables SQL analytics via Athena.",
  image: "/assets/awsetl.png", // 🔹 Put your project image in public/assets
  links: {
    github: "https://github.com/ashwindumane/AWS-Serverless-Orders-ETL-Pipeline"
  },
  tech: [
    "Amazon S3",
    "AWS Lambda",
    "AWS Glue",
    "Amazon Athena",
    "Python",
    "Serverless Architecture"
  ],
},
    {
      title: "PrepGenius",
      description:
        "AI-powered platform for personalized interview preparation with real-time question generation and smart note-taking.",
      image: "/assets/project1.png",
      links: {
        github: "https://github.com/ashwindumane/PrepGenius---Interview-Prep-AI",
        live: "https://prepgenius-ai-interview-prep-by-ash.vercel.app/",
      },
      tech: ["React", "Node.js", "Express.js", "MongoDB", "JWT", "Tailwind CSS", "Gemini API"],
    },
    {
      title: "PaisaTrack",
      description:
        "Real-time expense and income tracker with smart dashboards, data visualization, and secure user authentication.",
      image: "/assets/project2.png",
      links: {
        github: "https://github.com/ashwindumane/PaisaTrack-SMART-REALTIME-EXPENSE-TRACKER-",
        live: "https://paisatrack-smart-realtime-expense-tracker-by-ashwin.pages.dev/signup",
      },
      tech: ["React", "Node.js", "Express.js", "MongoDB", "JWT", "Chart.js", "Tailwind CSS"],
    },
    {
      title: "Narwade's Health Club",
      description:
        "Fullstack fitness website with BMI calculator, dynamic plans, contact form with email integration, and mobile-first design.",
      image: "/assets/project3.png",
      links: {
        github: "https://github.com/ashwindumane/Narwade-Health-Club",
        live: "https://ashwindumane-narwade-health-club.vercel.app/",
      },
      tech: ["React", "Node.js", "Express.js", "MongoDB", "Tailwind CSS", "Nodemailer"],
    },
    {
      title: "Notexa",
      description:
        "Full-featured MERN note-taking app with CRUD operations, offline support, search, and responsive UI.",
      image: "/assets/project4.png",
      links: {
        github: "https://github.com/ashwindumane/NOTEXA-MERN-Note-Taking-App",
        live: "https://notexa-note-app-by-ashwin-dumane.vercel.app/",
      },
      tech: ["React", "Node.js", "Express.js", "MongoDB", "JWT", "IndexedDB", "Tailwind CSS"],
    },
    {
      title: "FlipConvert",
      description:
        "Browser-based media converter using FFmpeg.wasm for image, audio, and video formats. 100% client-side.",
      image: "/assets/project5.png",
      links: {
        github: "https://github.com/ashwindumane/FlipConvert",
        live: "https://flip-convert.vercel.app/",
      },
      tech: ["React", "Tailwind CSS", "FFmpeg.wasm", "Framer Motion"],
    },
    {
      title: "ConvoWToPDF",
      description:
        "Secure and efficient Word-to-PDF converter with file upload handling and format preservation.",
      image: "/assets/project6.png",
      links: {
        github: "https://github.com/ashwindumane/ConvoWToPDF",
        live: "https://convowordtopdf.vercel.app/",
      },
      tech: ["React", "Node.js", "Express.js", "Multer", "LibreOffice", "Tailwind CSS"],
    },
    {
  title: "Tic-Tac-Toe Mania",
  description:
    "Interactive browser-based Tic-Tac-Toe game built using pure HTML, CSS, and JavaScript. Features real-time two-player gameplay with dynamic UI updates and win detection logic.",
  image: "/assets/tictactoe.png", // 🔹 Add screenshot image
  links: {
    github: "https://github.com/ashwindumane/Tic-Tac-Toe-Mania",
    live: "https://ashwindumane.github.io/Tic-Tac-Toe-Mania/"
  },
  tech: [
    "HTML",
    "CSS",
    "JavaScript",
    "GitHub Pages"
  ],
},

    {
  title: "QuickSketch – Collaborative Whiteboard",
  description:
    "Real-time collaborative whiteboard application that allows teams to brainstorm, draw, and annotate together instantly using Socket.IO. Supports full CRUD operations, real-time sync, and responsive design.",
  image: "/assets/quicksketch.png", 
  links: {
    github: "https://github.com/ashwindumane/QuickSketch-Realtime-WhiteBorad-App-",
  },
  tech: [
    "React",
    "Tailwind CSS",
    "Node.js",
    "Express.js",
    "Socket.IO",
    "Vercel"
  ],
},
{
  title: "NotesNow – Chrome Browser Extension",
  description:
    "Lightweight Chrome extension built with React and Tailwind CSS that allows users to quickly capture and manage notes directly from the browser with a clean, minimal UI.",
  image: "/assets/Extention.png", // 🔹 Add your screenshot image
  links: {
    github: "https://github.com/ashwindumane/NotesNow-A-Browser-Extension"
  },
  tech: [
    "React",
    "Tailwind CSS",
    "Chrome Extension API",
    "Vite"
  ],
},

    {
  title: "Linux Server Hardening & Automation (SecureLinuxOps)",
  description:
    "Hands-on Linux security project focused on hardening a CentOS Stream 9 server with SSH security, UFW firewall configuration, Fail2Ban intrusion prevention, automated backups using Bash & Cron, and system auditing with Auditd.",
  image: "/assets/linuxhardening.png", 
  links: {
    github: "https://github.com/ashwindumane/Linux-Server-Hardening-Automation"
  },
  tech: [
    "CentOS Stream 9",
    "SSH",
    "UFW",
    "Fail2Ban",
    "Bash",
    "Cron",
    "Auditd",
    "Oracle VirtualBox"
  ],
},
{
  title: "TaskHive – A Task Management App",
  description:
    "Full-stack task management application that allows users to create, update, delete, and track tasks with secure authentication and dynamic dashboard management.",
  image: "/assets/TaskHive.png", 
  links: {
    github: "https://github.com/ashwindumane/TaskHive"
  },
  tech: [
    "React",
    "Node.js",
    "Express.js",
    "MongoDB",
    "JWT",
    "MERN Stack"
  ],
},


  ];

  const infiniteProjects = [...projects, ...projects];

  useEffect(() => {
    const updateMetrics = () => {
      const vw = window.innerWidth;
      let cards = 3;
      if (vw <= 600) cards = 1;
      else if (vw <= 900) cards = 2;
      else if (vw <= 1200) cards = 2.5;
      setVisibleCards(cards);
      cards = visibleCards;

      const container = scrollRef.current;
      if (!container || !container.firstChild) return;

      const card = container.firstChild;
      const style = window.getComputedStyle(card);
      const gap = parseFloat(style.marginRight) || 0;
      setCardWidth(card.offsetWidth + gap);
    };

    updateMetrics();
    window.addEventListener("resize", updateMetrics);
    return () => window.removeEventListener("resize", updateMetrics);
  }, [visibleCards]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container || !cardWidth) return;

    const scrollOneCard = () => {
      if (stopRef.current || userScrolledRef.current) return;

      const max = container.scrollWidth / 2;
      let next = container.scrollLeft + cardWidth;

      if (next >= max) {
        container.scrollTo({ left: 0, behavior: "auto" });
        next = cardWidth;
      }
      container.scrollTo({ left: next, behavior: "smooth" });
    };

    playIntervalRef.current = setInterval(scrollOneCard, AUTO_PLAY_INTERVAL);
    return () => clearInterval(playIntervalRef.current);
  }, [cardWidth, AUTO_PLAY_INTERVAL]);

  const handleMouseEnter = () => (stopRef.current = true);
  const handleMouseLeave = () => (stopRef.current = false);

  const handleUserScroll = () => {
    userScrolledRef.current = true;
    clearTimeout(resumeTimeoutRef.current);
    resumeTimeoutRef.current = setTimeout(() => (userScrolledRef.current = false), RESUME_DELAY);
  };

  return (
    <section id="projects">
      <h1 className="projects-title">My Recent Works</h1>
      <p className="projects-subtitle">
        Explore some of the projects I've built using modern tech stacks.
      </p>

      <div
        className="projects-grid"
        ref={scrollRef}
        role="list"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onScroll={handleUserScroll}
      >
        {infiniteProjects.map((p, idx) => (
          <article key={idx} className="project-card color-container" role="listitem">
            <div className="project-image-container">
              <img
                src={p.image}
                alt={p.title}
                className="project-img"
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/assets/fallback.png";
                }}
              />
            </div>

            <div className="project-content">
              <h3 className="project-title">{p.title}</h3>
              <p className="project-description">{p.description}</p>

              <div className="tech-stack">
                {p.tech.map((t, i) => (
                  <span key={i} className="tech-badge">
                    {t}
                  </span>
                ))}
              </div>
            </div>

            <div className="project-footer-icons">
              {p.links?.live && p.links.live !== "#" && (
                <a
                  href={p.links.live}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Live Demo"
                  aria-label={`Live demo of ${p.title}`}
                >
                  <FaGlobe />
                </a>
              )}
              {p.links?.github && (
                <a
                  href={p.links.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="GitHub Code"
                  aria-label={`GitHub code of ${p.title}`}
                >
                  <FaGithub />
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
